import App from './pages/App.vue'

import store from './vuex/store'
import router from './router'
import { sync } from 'vuex-router-sync'

import Vue from 'vue'
import VueResource from 'vue-resource'
import VueAnimatedList from 'vue-animated-list'

Vue.use(VueAnimatedList)
Vue.use(VueResource)

import FontAwesome from 'font-awesome/css/font-awesome.css'
import Fullpage from 'fullpage.js/dist/jquery.fullpage.css'
import SweetAlert from 'sweetalert/dist/sweetalert.css'

sync(store, router)

router.start(App, '#app')

require('./plugins')



// WEBPACK FOOTER //
// ./src/main.js